<template>
    <rkm-area :title="`Setor de encaminhamento${required ? ' *' : ''}`">
        <Form :data="data" :required="required" />
    </rkm-area>
</template>

<script>
import Form from './Form'

export default {
    components: { Form },
    props: {
        data: { type: Object, required: true },
        required: { type: Boolean, default: true }
    },
}
</script>